angular.module('clientDashboardApp').factory('emailAlertService', function ($q, $http) {

  // To test locally, use the css-inliner repo, ex: "http://localhost:3000/api"
  const apiUrl = "https://services.chatmeter.com/css-inliner/api";

  function fixGoogleMaps(alert) {
    if (alert.filter && alert.filter.providers) {
      alert.filter.providers = alert.filter.providers.map(p => p == 'GOOGLEMAP' ? 'GOOGLE' : p)
    }
    (alert.gadgets || []).forEach(g => g.providers ? g.providers = g.providers.map(p => p == 'GOOGLEMAP' ? 'GOOGLE' : p) : null)
    return alert
  }

  return {
    getAlert: (id) => {
      return $http.get(`/v5/alerts/${id}`).then(res => fixGoogleMaps(res.data))
    },
    getAlerts: (offset, limit, filters, subjectQuery) => {
      const params = {offset, limit, ...filters, subjectQuery}
      return $http.get('/v5/alerts', {params}).then(res => {
        return {alerts: res.data.alerts.map(alertWithMeta => ({...alertWithMeta, alert: fixGoogleMaps(alertWithMeta.alert)})), total: res.data.total}
      })
    },
    saveAlert: (alert) => {
      return $http.post('/v5/alerts',alert)
    },
    deleteAlert: (id) => {
      return $http.delete(`/v5/alerts/${id}`)
    },
    sendTest: (id, toAddress, startDate) => {
      return $http.post(`/v5/alerts/${id}/test`, {to: toAddress, startDate: startDate})
    },
    compileHbs: (params) => {
      return $http.post(apiUrl + '/render', params)
    },
    inlineScss: (html,css) => {
      return $http.post(apiUrl + '/inline', {html,css})
    },
    compileScss: (scss) => {
      return $http.post(apiUrl + '/compileScss', {scss})
    },
    subscribe: (alertId) => {
      return $http.put(`/v5/alerts/${alertId}/subscriptions`)
    },
    unsubscribe: (alertId) => {
      return $http.delete(`/v5/alerts/${alertId}/subscriptions`)
    },
    save: (alert) => {
      return $q.when(alert)
    }
  }

})
